import React, { useState, useContext } from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import ReactDatePicker from "react-datepicker";
import { BsClockFill, BsFillCalendarEventFill } from "react-icons/bs";

import FieldError from "../../../shared/FieldError";
import { Settings } from "../../../helpers/Contexts";

const Rescheduled = ({ data }) => {
  const AppointmentDateSchema = Yup.object().shape({
    appointment_time: Yup.string().matches(
      "([01]?[0-9]|2[0-3]):[0-5][0-9]",
      "Time value must be in valid hh:mm military or 12 hour format. Include AM/PM if using 12 hour format. "
    ),
    appointment_date: Yup.date().required("Appointment date is required"),
  });

  return (
    <Formik
      validationSchema={AppointmentDateSchema}
      validateOnChange={true}
      initialValues={{
        date: data.appointment_date,
        appointment_date: new Date(data.appointment_date).toISOString(),
        appointment_time: new Date(data.appointment_time).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        }),
      }}
      onSubmit={(values) => {
        data.formHandler({
          task: {
            id: data.id,
            status: "open",
            appointment_request_status: "appointment_confirmed",
            appointment_date: values.appointment_date,
            appointment_time: values.appointment_time,
            extended: true,
            priority: null,
          },
        });
      }}
    >
      {({ values, setFieldValue, errors, touched }) => {
        return (
          <>
            <Form>
              <>
                <br />
                <b>Update the following fields with the new Scheduled Appointment Date & Time </b>
                <label>Appointment Date & Time</label>
                <div className="flex">
                  <div className={"flex datefield-wrapper"}>
                    <Field name={"date"}>
                      {({ field, meta }) => {
                        return (
                          <>
                            <BsFillCalendarEventFill className="calendar-icon" />
                            <ReactDatePicker
                              {...field}
                              autoComplete="off"
                              className="datepicker"
                              dateFromat={"YYYY-MM-dd"}
                              onChange={(date) => {
                                setFieldValue("appointment_date", date);
                                setFieldValue("date", date.toISOString().slice(0, 10));
                              }}
                            />
                          </>
                        );
                      }}
                    </Field>
                  </div>
                  <div className={"flex datefield-wrapper"}>
                    <BsClockFill className="calendar-icon" />
                    <Field name="appointment_time" className="time" />
                  </div>
                </div>
                {errors.appointment_date ? <FieldError error={errors.appointment_date} /> : null}
                {errors.appointment_time ? <FieldError error={errors.appointment_date} /> : null}
              </>

              <button className="check" type="submit">
                Submit New Scheduled Appointment
              </button>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default Rescheduled;
